import { Spin } from 'antd';
import * as React from 'react';
import { useNavigate } from 'react-router';

import { routes } from 'config/routes';
import { useBasicFormStore } from 'stores/local';

import s from './FormInitPage.module.scss';

const FormInitPage: React.FC = () => {
  const navigate = useNavigate();

  const basicFormStore = useBasicFormStore();

  React.useEffect(() => {
    const init = async () => {
      await basicFormStore.createForm();

      if (basicFormStore.id) {
        navigate(routes.form.formSteps.createPath(basicFormStore.id), {
          replace: true,
        });
      }
    };

    init();
  }, [basicFormStore, navigate]);

  return (
    <div className={s['create-form-page']}>
      <Spin />
    </div>
  );
};

export default FormInitPage;
